import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpCssClient } from '../shared/http-request.interceptor';

import { Cookie } from '../shared/cookie.service';

@Injectable()
export class SuperInterceptor implements CanActivate {
    private __cookie:Cookie;

    constructor(router: Router, cookie: Cookie) {
        this.__cookie = cookie;
    };

    canActivate(prev: ActivatedRouteSnapshot, next: RouterStateSnapshot) {
        /** Adding Front-End version */
        if(prev.queryParams['utm_source'] != null){
            let utm = {
                utmSource:prev.queryParams['utm_source'],
                utmMedium:prev.queryParams['utm_medium'],
                utmCampaign: prev.queryParams['utm_campaign'],
                utmTerm: prev.queryParams['utm_term'],
                utmContent: prev.queryParams['utm_content']
            };
            this.__cookie.put("__utm__", JSON.stringify(utm), 30*24*60*60*1000);
        }
        return true;
    }
}